import { TFunction } from "i18next";
import * as Yup from "yup";

export const getEventModalEndDateSchema = (t: TFunction, startDate: Date | string | null) => {
    return Yup.object().shape({
        endDate: Yup.date()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm"))
            .test(
                'end-after-start',
                t("common:form.messageErrorStartDateAfterFinishDate"),
                function (endDate) {
                    if (!endDate || !startDate) return true;

                    const normalizeToMidnight = (d: Date | string): Date => {
                        const date = new Date(d);
                        date.setHours(0, 0, 0, 0); // elimina la parte de hora
                        return date;
                    };

                    const start = normalizeToMidnight(startDate);
                    const end = normalizeToMidnight(endDate);

                    if (isNaN(start.getTime())) return true;

                    return end >= start;
                }
            ),
    });
};


export const getEventFormSchema = (t: TFunction) => {

    return Yup.object().shape({
        description: Yup.string()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
        startDate: Yup.date()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
        endDate: Yup.string()
            .nullable()
            .test('is-valid-date', t("common:form.invalidDateForm"), (value) => {
                if (!value) return true; // null o vac�o es v�lido
                const date = new Date(value);
                return !isNaN(date.getTime());
            })
            .test(
                'end-after-start',
                t("common:form.messageErrorStartDateAfterFinishDate"),
                function (endDate) {
                    if (!endDate) return true; // endDate es opcional

                    const { startDate } = this.parent;
                    if (!startDate) return true;

                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    return end >= start;
                }
            ),
    });
};